import SelectImage from "@builder/components/general/SelectImage";
import TextInput from "@builder/components/general/TextInput";
import { getSelectedNode } from "@builder/store/slices/BuilderSlice/builderSelectors";
import { updateNodeProperty } from "@builder/store/slices/BuilderSlice/builderSlice";
import { setCurrentPopup, setImageState } from "@builder/store/slices/popupSlice";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
import { TemplateDiv } from "@common/build/types";
import SidebarCollapse from "../../../app/SidebarCollapse";
import { EditableProps } from "../../editableProps";

/**
 * template name would determine the name that will show in design sets
 * template image would be displayed in the design sets instead of using user data - if exists
 * template tag would be used to filter the design sets
 * - for example, tag product-grid would be filter for when templates popup automatically opens at adding product grid 
 */

const EditTemplateDiv: React.FC<EditableProps> = ({ parent }: EditableProps) => {
    const dispatch = useAppDispatch();
    const node = useAppSelector(getSelectedNode) as TemplateDiv;

    const customName = node?.customName;
    const cNameCallback = (value: string) => {
        dispatch(updateNodeProperty({ propertyPath: ["customName"], value }));
    };

    const customTag = node?.tag;
    const cTagCallback = (value: string) => {
        dispatch(updateNodeProperty({ propertyPath: ["tag"], value }));
    };


    const imageCallback = () => {
        dispatch(setImageState(["previewImage"]));
        dispatch(setCurrentPopup("images"));
    };

    const removeImageCallback = () => {
        dispatch(updateNodeProperty({ propertyPath: ["previewImage"], value: "", remove: true }));
    };

    return (
        <SidebarCollapse title="Template Div" parent={parent}>
                <TextInput title="Template name" value={customName} placeholder="Enter template name" callback={cNameCallback} />
                 <SelectImage type="image" callback={imageCallback} removeCallback={removeImageCallback} img={node?.previewImage} />
                <TextInput title="Template tag" value={customTag} placeholder="Enter template tag" callback={cTagCallback} />
        </SidebarCollapse>
    );
};

export default EditTemplateDiv;
